export const frameCombinationsToBlock = [
    {"Frame": "K2", "Material": "poly", "MaterialLong": "Polycarbonate"}, 
    {"Frame": "Risso", "Material": "poly", "MaterialLong": "Polycarbonate"}
];
